import { addChatToArchive, setChatOperationPending } from './actions';
import {
  fetchChatsMoveToArchiveDesktop,
  TChatsMoveToArchiveDesktopResponse,
} from '../../repositories/chats/v1/chats/move-to-archive-desktop';
import { showAlert } from '../../slices/alertSlice';
import { EAlert } from '../../types/alert';
import { TThunkAction } from '../../types/redux/thunk';
import { increaseCountClosedChats } from '../chatWindow';

/**
 * Пытаемся переместить чат в архив
 */
export const moveToArchive =
  (chatId: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    dispatch(increaseCountClosedChats());

    dispatch(setChatOperationPending(true));

    try {
      const { statusCode, response }: TChatsMoveToArchiveDesktopResponse = await fetchChatsMoveToArchiveDesktop({
        httpApi,
        parameters: { chatId },
        config: { requestConfig: { withCredentials: true } },
      });

      dispatch(setChatOperationPending(false));

      // @ts-expect-error в модели response не хватает описания 204 ответа
      if (statusCode === 200 || statusCode === 204) {
        dispatch(addChatToArchive(chatId));

        /**
         * При успешном перемещении в архив, показываем алерт отмены
         */
        dispatch(showAlert({ type: EAlert.Archive }));

        return;
      }

      /**
       * При неудачной попытке перенести чат в архив, показываем алерт с ошибкой
       */
      dispatch(showAlert({ message: response.message || 'Возникла ошибка при попытке перенести чат в архив' }));
    } catch (error) {
      logger.error(error, {
        chatId,
        domain: 'frontend-chats.actions.moveToArchive',
        description: 'Ошибка при попытке перенести в архив',
      });

      dispatch(setChatOperationPending(false));
      dispatch(showAlert({}));
    }
  };
